'use strict';

let packagenamePass = (rule, value, callback) => {
    let reg = /^[\w][\w\d]*([.][\w][\w\d]*)+$/;
    if(value){
        reg.test(value) ?  callback() : callback(new Error("格式错误,例如com.mapbar.com"));
    };
};
let deviceIdListPass = (rule, value, callback) => {
    if(value.some(item => { return item == ''})){
        callback(new Error("不可为空"));
    }else{
        callback();
    }
}
const userPhoneReg = /^1[345678]\d{9}$/;
function validateUserPhone(rule, value, callback) {
    if ( userPhoneReg.test(value)) {
        callback();
    } else callback('手机号格式错误');
}
const userEmailReg=/^([a-zA-Z0-9]+[_|_|.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|_|.]?)*[a-zA-Z0-9]+\.(?:com|cn)$/;
function validateEmail(rule,value,callback) {
    if (userEmailReg.test(value)){
        callback();
    } else callback('邮箱格式错误，请重新填写')
}

function getRules() {
    return {
        title:[
            {required: true, message: '不可为空', trigger: 'change,blur'},
        ],
        group:[
            {required: true, message: '不可为空', trigger: 'change,blur'},
        ],
        phone:[
            {required: true, message: '不可为空', trigger: 'change,blur'},
            {validate: validateUserPhone, message: '手机号格式错误', trigger: 'change,blur'},
        ],
        email:[
            {required: true, message: '请输入邮箱', trigger: 'change,blur'},
            {validator: validateEmail, trigger: 'change,blur'},
        ],
        anonymous:[
            {required: true, message: '不可为空', trigger: 'change,blur'},
        ],
        endTime:[
            {required: true, message: '不可为空', trigger: 'change,blur'},
        ],
        priority:[
            {required: true, message: '不可为空', trigger: 'change,blur'},
        ],
        changeOrigin:[
            {required: true, message: '不可为空', trigger: 'change,blur'},
        ],
        influence:[
            {required: true, message: '不可为空', trigger: 'change,blur'},
        ],
        emergency:[
            {required: true, message: '不可为空', trigger: 'change,blur'},
        ],

        apptype:[
            {required: true, message: '不可为空', trigger: 'change,blur'},
        ],
        packagename:[
            {required: true, message: '不可为空', trigger: 'change,blur'},
            { max:128, message: '最大长度为128', trigger: 'change,blur'},
            { validator:packagenamePass ,trigger: 'change,blur'}
        ],
        remark:[
            { max:100, message: '最大长度为100', trigger: 'change,blur'},
        ],

        message:[
            {required: true, message: '不可为空', trigger: 'change,blur'},
            { max:100, message: '最大长度为100', trigger: 'change,blur'}
        ],
        deviceIdList:[
            {required: true, message: '不可为空', trigger: 'change,blur'},
            { validator:deviceIdListPass ,trigger: 'change,blur'}
        ]


    };
}
export {
    getRules
}
